import React, { useEffect, useState } from "react";
import PlanCard from "./planCard";
import PaymentPage from "./PaymentPage";
import CredentialService from '../../Services/credential.services';
import TokenService from "../../Services/token.service";
import IntelliPayForm from "../user/insurances/payment/intelliPayForm";

export default function PriceOptions(props:any) {
    const [dataLoaded, setDataLoaded]=useState(false);
    const [totalPrice, setTotalPrice]=useState(0.0);
    const [unitPrice, setUnitPrice]=useState(0.0);
    const [companies, setCompanies]=useState(0.0);
    const [collectPayment, setCollectPayment]=useState(false);
    const [paymentTerm, setPaymentTerm]=useState("");
    const [userEmail, setUserEmail]=useState("");
    const [userId, setUserId]=useState("");
    const [isPaymentAnnual, setIsPaymentAnnual]=useState("false");
    const [canPay, setCanPay] = useState('false');
    const [companyCount, setCompanyCount] = useState(0)

    useEffect(()=>{
        GetPricingOptions();
        setUserEmail(TokenService.getUser().user.email);
        setUserId(TokenService.getUser().user.id);
    },[]); 



const GetPricingOptions = async()=>{
    setDataLoaded(false);
    var response= await CredentialService.GetPricing()
    console.log(response);
    if(response.success){
        console.log(response.data.totalCost);
        setTotalPrice(response.data.totalCost);
        setUnitPrice(response.data.unitCost);
        setCompanies(response.data.insuranceCompanies);
        setCanPay(response.data.canPay);
        setDataLoaded(true);
        setCompanyCount(response.data.companyCount);
        
        console.log(response);
    }   
}

const choosePricingOption = (isAnnual:boolean) => {

    setCollectPayment(true);
}

  return (
    <div>
        
        {dataLoaded? 
            <div className="">
                <div className="">
                    <h1 className="font-medium leading-tight text-4xl mt-0 mb-12 text-black-600 text-center">
                    You are just one step away!
                    </h1>
                    <div className="flex items-center justify-center min-h-screen bg-gray-100 grid-cols-2 gap-4">
                        <PlanCard price={totalPrice} unitPrice={unitPrice} insuranceCompanies={companies} choosePricingOption={choosePricingOption} canPay={canPay}></PlanCard>
                    </div>
                </div>
                {collectPayment && <PaymentPage paymentAmount={totalPrice} collectPayment={collectPayment} userEmail={userEmail} userId={userId} />}
            </div> 
            :
            <div className="loader-container">
                <div className="spinner"></div>
            </div>
        }   
    </div>
  );
}


